module.exports = __webpack_public_path__ + "img/button.bdaca53a.png";